import HTTPClient from './HTTPClient';
function createAPIClient(baseURL, token) {
    return new HTTPClient(baseURL, token);
}
export default createAPIClient;
